<div class="row nowrap stretch margin-bottom-20 flex">
    <mat-card class="col-left">
        <h2 class="border-bottom-none">Scan location</h2>

        <div class="bordered-box margin-bottom-20" [class.bordered-box-active]="!location">
            <table>
                <tr>
                    <td width="60">
                        <i class="fa fa-barcode fa-4x text-success"></i>
                    </td>
                    <td>
                        <mat-form-field style="width: 100%">
                            <mat-label>Location</mat-label>
                            <input matInput [formControl]="searchLocation">
                        </mat-form-field>
                    </td>
                    <td width="110">
                        <button type="button" mat-raised-button color="success"
                                [disabled]="!searchLocation.value"
                                (click)="findLocation()">
                            <i class="fa fa-barcode"></i>
                            Search
                        </button>
                    </td>
                </tr>
            </table>

            <div class="text-center">
                Your scanner default key set as {{ scannerKey }}.
                <span *ngIf="scannerOnly">Manual input disabled</span>
            </div>
        </div>

        <div class="margin-bottom-10">
            <button type="button" mat-raised-button color="primary" (click)="locationList()">
                Available locations
            </button>

            <button type="button" mat-raised-button color="primary" class="pull-right" (click)="addLocation('')">
                Add location
                <mat-icon>add</mat-icon>
            </button>
            <div class="clear"></div>
        </div>


        <div class="bordered-box margin-bottom-20">
            <div>
                <table>
                    <tr>
                        <td width="30">
                            <mat-icon>location_city</mat-icon>
                        </td>
                        <td>
                            <h2>Selected location</h2>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <b *ngIf="location" class="text-success" style="font-size: 140%;">
                                {{ location.name }}
                                <span *ngIf="location.hub">({{ location.hub.customers_sub_inventory }})</span>
                            </b>
                            <b *ngIf="!location" class="color-warn" style="font-size: 140%;">
                                not selected
                            </b>
                        </td>
                    </tr>
                </table>
            </div>
        </div>


    </mat-card>

    <mat-card class="col-center max margin-right-10 margin-left-10">
        <h2 class="border-bottom-none">Scan item</h2>

        <div class="bordered-box margin-bottom-20" [class.bordered-box-active]="location">
            <div *ngIf="!location" class="text-center">
                <h2 class="color-warn">Select location first</h2>
            </div>
            <table class="search-field" *ngIf="location">
                <tr>
                    <td width="60">
                        <i class="fa fa-barcode fa-4x text-success"></i>
                    </td>
                    <td>
                        <mat-form-field style="width: 100%">
                            <mat-label>Serial, box, pallet</mat-label>
                            <input matInput type="search"
                                   [formControl]="searchInput"
                                   [scannerOnly]="scannerOnly"
                                   (keydown)="onKeydown($event)" #searchInputRef>
                        </mat-form-field>
                    </td>
                    <td width="110">
                        <button type="button" mat-raised-button color="success" (click)="find()"
                                [disabled]="!searchInput.value">
                            <i class="fa fa-barcode"></i> Search
                        </button>
                    </td>
                </tr>
            </table>
            <div class="text-center">
                <span *ngIf="scannerKey">Your scanner default key set as {{ scannerKey }}.</span>
                <span *ngIf="scannerOnly" class="color-warn">Manual input disabled</span>
                <div class="color-accent">
                    Only items with serial, box or pallet can be scanned using this procedure.
                    <br>Unserialized items must be processed in respectful order scan procedure.
                </div>
            </div>

        </div>


        <div class="bordered-box">

            <div class="flex row align-center">
                <h2 class="max border-bottom-none">
                    Order list
                </h2>
            </div>

            <div class="flex row align-center">
                <mat-form-field class="half">
                    <mat-label>Search order ref</mat-label>
                    <input type="text" matInput [formControl]="inboundItemsSearch">
                </mat-form-field>
            </div>


            <div class="scroll-list">

                <div *ngFor="let order of orders  | search: inboundItemsSearch.value: ['ref']"
                     class="margin-bottom-10 item">
                    <table>
                        <tr>
                            <td width="30">
                                <img [src]="order.partner.icon_path" width="30" height="30"
                                     [alt]="order.partner.display_name"
                                     [title]="order.partner.display_name">
                            </td>
                            <td>
                                Order: <b>{{ order.ref }}</b>
                            </td>
                            <td class="text-right vertical-middle">
                                <div style="display:inline-block" class="vertical-middle">
                                    <div class="chipsa background-success"
                                         [class.background-success]="order.scanned===order.inbound_order_item_sum_quantity"
                                         [class.background-danger]="order.scanned!==order.inbound_order_item_sum_quantity">
                                        <mat-icon>check_circle</mat-icon>
                                        Scanned {{ order.scanned }} of {{ order.inbound_order_item_sum_quantity }}
                                    </div>
                                </div>
                                &nbsp;
                                <button mat-mini-fab class="pointer vertical-middle" matTooltip="Open order"
                                        (click)="openOrder(order)">
                                    <mat-icon>arrow_forward</mat-icon>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>

            </div>
        </div>

    </mat-card>

    <mat-card class="col-right">
        <h2 class="border-bottom-none">Scan feed</h2>

        <div class="bordered-box">

            <div class="text-right">
                <button mat-raised-button type="button" color="warn"
                        *ngIf="checkedFeedItems.length"
                        (click)="deleteScans(checkedFeedItems)">
                    Delete selected
                </button>
                &nbsp;
                <mat-form-field>
                    <mat-label>Search by pallet, boxes, items</mat-label>
                    <input type="text" matInput #feedSearch>
                </mat-form-field>
            </div>

            <div class="margin-bottom-10">
                <mat-checkbox [formControl]="showOnlyFailedScans">
                    Show only failed scans
                </mat-checkbox>


                <mat-checkbox [formControl]="selectAll" matTooltip="Select all scans"
                              class="pull-right margin-right-20"></mat-checkbox>
            </div>

            <div class="totals clear margin-bottom-20">
                <div class="chipsa">
                    <mat-icon class="vertical-middle">pallet</mat-icon>
                    {{ totalScanned.pallets }} pallets
                </div>
                <div class="chipsa">
                    <mat-icon class="vertical-middle">inventory_2</mat-icon>
                    {{ totalScanned.boxes }} boxes
                </div>
                <div class="chipsa">
                    <mat-icon class="vertical-middle">category</mat-icon>
                    {{ totalScanned.items }} items
                </div>
            </div>

            <mat-tab-group>
                <mat-tab label="All">
                    <div class="scroll-list clear" style="max-height:750px;">
                        <div *ngIf="scanFeed.length === 0">
                            <p class="text-center">
                                Feed is empty
                            </p>
                        </div>
                        <ng-container
                                *ngFor="let feed_item of scanFeed | search: feedSearch.value:['item','box','serial','pallet']">
                            <div class="margin-bottom-10 item"
                                 *ngIf="!showOnlyFailedScans.value || showOnlyFailedScans.value && feed_item.status ==='error'">
                                <table>
                                    <tr>
                                        <td width="30" rowspan="2" class="vertical-top">
                                            <div *ngIf="feed_item.status==='pending'; else scantype">
                                                <mat-icon class="status pending">settings</mat-icon>
                                            </div>
                                            <ng-template #scantype>
                                                <mat-icon *ngIf="feed_item.type==='pallet'">pallet</mat-icon>
                                                <mat-icon *ngIf="feed_item.type==='box'">inventory_2</mat-icon>
                                                <mat-icon *ngIf="feed_item.type==='item'">category</mat-icon>
                                                <mat-icon *ngIf="feed_item.type==='serial'">category</mat-icon>
                                            </ng-template>
                                        </td>
                                        <td class="vertical-top">
                                            <div *ngIf="feed_item.type==='pallet'">
                                                Pallet: <b>{{ feed_item.pallet }}</b>
                                            </div>

                                            <div *ngIf="feed_item.type==='box'">
                                                Box: <b>{{ feed_item.box }}</b>
                                            </div>

                                            <ng-container *ngIf="feed_item.type==='item' || feed_item.type==='serial'">
                                                <div>
                                                    Item: <b>{{ feed_item.item }}</b>
                                                </div>

                                                <div *ngIf="feed_item.serial">
                                                    Serial: <b>{{ feed_item.serial }}</b>
                                                </div>

                                                <div *ngIf="feed_item.batch">
                                                    Batch: <b>{{ feed_item.batch }}</b>
                                                </div>

                                                <div *ngIf="feed_item.quantity > 1">
                                                    Qty: <b>{{ feed_item.quantity }}</b>
                                                </div>
                                            </ng-container>

                                            <div>
                                                Location: {{ feed_item.location }}
                                            </div>

                                        </td>
                                        <td width="30" class="text-center vertical-top">
                                            <mat-checkbox
                                                    [checked]="checkedFeedItems.includes(feed_item.feed_id)"
                                                    (change)="$event.checked ? selectScan(feed_item.feed_id): deSelectScan(feed_item.feed_id)">
                                            </mat-checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div *ngIf="feed_item.message"
                                                 class="chipsa"
                                                 [class.background-success]="feed_item.status==='success'"
                                                 [class.background-danger]="feed_item.status==='error'">
                                                <div>
                                                    <mat-icon>
                                                        {{ feed_item.status === 'success' ? "check_circle" : "error" }}
                                                    </mat-icon>
                                                </div>
                                                <div>
                                                    {{ feed_item.message }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <mat-icon class="status color-warn pointer"
                                                      matTooltip="Delete scan"
                                                      (click)="deleteScans([feed_item.feed_id])">
                                                delete
                                            </mat-icon>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </ng-container>
                    </div>
                </mat-tab>
                <mat-tab label="Grouped">
                    <div class="scroll-list clear" style="max-height:750px;">
                        <div *ngIf="scanFeedGrouped.length === 0">
                            <p class="text-center">
                                Feed is empty
                            </p>
                        </div>
                        <div *ngFor="let feed_group of scanFeedGrouped">
                            <div class="margin-bottom-10 padding-right-10 padding-left-10 background-success location flex row space-between align-center ">
                                <b class="max padding-top-5 padding-bottom-5">Location: {{ feed_group.location }}</b>
                            </div>

                            <div class="margin-bottom-10 item" *ngIf="feed_group.pallets.length > 0">
                                <table>
                                    <tr>
                                        <td width="30" class="vertical-top">
                                            <div>
                                                <mat-icon>pallet</mat-icon>
                                            </div>
                                        </td>
                                        <td class="vertical-top">
                                            Pallets QTY: {{ feed_group.pallets.length }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <mat-icon class="vertical-middle pointer"
                                                          (click)="showScansFromLocation(feed_group.pallets)">
                                                    fact_check
                                                </mat-icon>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="chipsa background-success">
                                                <div>
                                                    <mat-icon>check_circle</mat-icon>
                                                </div>
                                                <div>
                                                    Total {{ feed_group.pallets_quantity }} item(s) ready to inbound
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div class="margin-bottom-10 item" *ngIf="feed_group.boxes.length > 0">
                                <table>
                                    <tr>
                                        <td width="30" class="vertical-top">
                                            <div>
                                                <mat-icon>inventory_2</mat-icon>
                                            </div>
                                        </td>
                                        <td class="vertical-top">
                                            Boxes QTY: {{ feed_group.boxes.length }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <mat-icon class="vertical-middle pointer"
                                                          (click)="showScansFromLocation(feed_group.boxes)">
                                                    fact_check
                                                </mat-icon>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="chipsa background-success">
                                                <div>
                                                    <mat-icon>check_circle</mat-icon>
                                                </div>
                                                <div>
                                                    Total {{ feed_group.boxes_quantity }} item(s) ready to inbound
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div class="margin-bottom-10 item" *ngIf="feed_group.items.length > 0">
                                <table>
                                    <tr>
                                        <td width="30" class="vertical-top">
                                            <div>
                                                <mat-icon>category</mat-icon>
                                            </div>
                                        </td>
                                        <td class="vertical-top">
                                            Items QTY: {{ feed_group.items.length }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <mat-icon class="vertical-middle pointer"
                                                          (click)="showScansFromLocation(feed_group.items)">
                                                    fact_check
                                                </mat-icon>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="chipsa background-success">
                                                <div>
                                                    <mat-icon>check_circle</mat-icon>
                                                </div>
                                                <div>
                                                    Total {{ feed_group.items_quantity }} item(s) ready to inbound
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                    </div>
                </mat-tab>
            </mat-tab-group>

        </div>
    </mat-card>
</div>

<mat-card>
    <div>
        <div class="text-left">
            <div class="color-accent margin-bottom-10">
                Press "Finish scan" button to complete scanning procedure.
                Only valid scans will be converted to transactions.
            </div>
            <button mat-raised-button color="accent" (click)="completeScanning()">
                Finish scan
            </button>
        </div>
    </div>
</mat-card>

<common-confirm></common-confirm>